
























































import { Component, Watch } from 'vue-property-decorator';
import { CustomerModule } from '@/store/Customers/CustomerModule';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import Customer from '@/models/Customers/Customers/Customer';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { Debounce } from 'vue-debounce-decorator';

@Component({ name: 'Customers', components: { Alert }, metaInfo: { title: 'Customers' } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.customers.fields.name'), sortable: false, width: '35%' },
        { text: this.$t('pageText.customers.fields.type'), sortable: false, width: '15%' },
        { text: this.$t('pageText.customers.fields.accountHolders'), sortable: false, width: '30%' },
        { text: this.$t('pageText.customers.fields.updatedAt'), sortable: false, width: '20%' }
    ];
    customersPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.customersPage = +page;
        }
    }

    async beforeMount() {
        await CustomerModule.getCustomers(this.customersPage);
    }

    get customers() {
        return CustomerModule.customers;
    }

    get totalCustomersPages() {
        return CustomerModule.totalCustomersPages;
    }

    get search() {
        return CustomerModule.customersSearch;
    }

    set search(searchText: string) {
        CustomerModule.updateCustomersSearch(searchText);
    }

    get loading() {
        return CustomerModule.loading;
    }

    get pageSize() {
        return CustomerModule.pageSize;
    }

    @Watch('customersPage')
    async onCustomersChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.customersPage}` } });
        // Get new customers
        await CustomerModule.getCustomers(this.customersPage);
    }

    // Wait before auto-searching to allow the user to type more
    @Debounce(500)
    @Watch("search", { immediate: false, deep: true })
    async searchChanged() {
        // Note that when the search changes it puts the user back to the first page, incase there are new customers
        this.customersPage = 1;
        await CustomerModule.getCustomers(1);
    }

    async navigateToCustomer(customer: Customer) {
        this.$router.push({ name: PageNames.Customer, params: { id: customer.id }, query: { tab: "0" } });
    }

}
